module.exports = __webpack_public_path__ + "img/varus.163a8370.jpg";